import { MenuItem, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { useMutation } from "react-query";
import BootstrapModal from "react-bootstrap/Modal";
import useLang from "Shared/hooks/useLanguage";
import { toast } from "react-toastify";
import {
  StyledDropButtonThreeDots,
  StyledDropMenuMoreAction,
} from "Utils/Style/Dropdownstyle";
import { InstrumentToggleStatus } from "Services/Instrument/Instrument";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";

function InactiveInstrumentRow({ row, refetch }: any) {
  const { t } = useLang();
  const [anchorEl, setAnchorEl] = useState<any>({ dropdown1: null });
  const [showActivateModal, setShowActivateModal] = useState(false);

  const handleClick = (event: any, dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: event.currentTarget });
  };

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  /* -------- useMutation: Activate -------- */
  const activateMutation = useMutation(
    (instrumentId: number) => InstrumentToggleStatus(instrumentId),
    {
      onSuccess: (res: any) => {
        if (res?.data?.statusCode === 200) {
          toast.success(res?.data?.data?.message);
          handleClose("dropdown1");
          setShowActivateModal(false);
          refetch();
        } else {
          toast.error(res?.data?.data?.message || t("Something went wrong."));
        }
      },
      onError: () => {
        toast.error(t("An unexpected error occurred."));
      },
    }
  );

  const handleActivate = () => {
    if (!row.instrumentId) return toast.info(t("No Row Selected"));
    activateMutation.mutate(row.instrumentId);
  };

  const openActivateModal = () => {
    handleClose("dropdown1");
    setShowActivateModal(true);
  };

  return (
    <>
      <TableRow className="h-30px" key={row.instrumentId}>
        {/* Actions */}
        <TableCell>
          <div className="d-flex justify-content-center">
            <StyledDropButtonThreeDots
              id={`InstrumentInactive3Dots_${row.instrumentId}`}
              aria-haspopup="true"
              onClick={(event: any) => handleClick(event, "dropdown1")}
              className="btn btn-light-info btn-sm btn-icon moreactions min-w-auto rounded-4"
            >
              <i className="bi bi-three-dots-vertical p-0 icon"></i>
            </StyledDropButtonThreeDots>
            <StyledDropMenuMoreAction
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl.dropdown1}
              open={Boolean(anchorEl.dropdown1)}
              onClose={() => handleClose("dropdown1")}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <PermissionComponent
                moduleName="Oncology LIS"
                pageName="Instruments"
                permissionIdentifier="Active"
              >
                {({ pageName, moduleName, permissionIdentifier }) => (
                  <MenuItem className="p-0">
                    <a
                      id={`InstrumentInactiveActivate_${row.instrumentId}`}
                      className="w-150px p-0 text-dark"
                      onClick={openActivateModal}
                    >
                      <div className="menu-item px-3">
                        <i className="fa fa-check-circle text-primary mr-2 w-20px" />
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Active"
                        )}
                      </div>
                    </a>
                  </MenuItem>
                )}
              </PermissionComponent>
            </StyledDropMenuMoreAction>
          </div>
        </TableCell>

        {/* Instrument Name */}
        <TableCell
          id={`InstrumentInactiveName_${row.instrumentId}`}
          sx={{ width: "max-content" }}
        >
          <div style={{ width: "max-content" }}>{row.instrumentName}</div>
        </TableCell>

        {/* Instrument Description */}
        <TableCell
          id={`InstrumentInactiveDescription_${row.instrumentId}`}
          sx={{ width: "max-content" }}
        >
          <div style={{ width: "max-content" }}>{row.instrumentDescription}</div>
        </TableCell>

        {/* Instrument Type */}
        <TableCell
          id={`InstrumentInactiveType_${row.instrumentId}`}
          sx={{ width: "max-content" }}
        >
          <div style={{ width: "max-content" }}>{row.instrumentType}</div>
        </TableCell>
      </TableRow>

      {/* Activate Confirmation Modal */}
      <BootstrapModal
        show={showActivateModal}
        onHide={() => setShowActivateModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <BootstrapModal.Header closeButton className="bg-light-primary m-0 p-5">
          <h4>{t("Active Instrument")}</h4>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          {t("Are you sure you want to activate this instrument?")}
        </BootstrapModal.Body>
        <BootstrapModal.Footer className="p-0">
          <button
            id={`InstrumentInactiveModalActivateCancel_${row.instrumentId}`}
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowActivateModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            id={`InstrumentInactiveModalActivateConfirm_${row.instrumentId}`}
            type="button"
            className="btn btn-danger m-2"
            onClick={handleActivate}
          >
            {t("Active")}
          </button>
        </BootstrapModal.Footer>
      </BootstrapModal>
    </>
  );
}

export default InactiveInstrumentRow;
